module.exports = __webpack_public_path__ + "img/banner.59b2e7ff.jpg";